<template>

    <v-modal
        :open="open"
        class="c-modal_remove_issue">
        <h2>Usuń problem</h2>
        <p class="c-modal_remove_issue__content">Usunięcie spowoduje także skasowanie wszystkich wizyt w ramach tego
            problemu.</p>
        <p class="c-modal_remove_issue__question">Czy na pewno chcesz usunąć?</p>
        <div>
            <v-btn
                type="red-white"
                @click="cancel">
                Anuluj
            </v-btn>
            <v-btn
                type="red"
                @click="ok"
                has-loader
                :loading="isLoading">
                Tak, usuń
            </v-btn>
        </div>
    </v-modal>

</template>


<script>

import VModal from 'Components/VModal'
import VBtn from 'Components/VBtn'

export default {

    name: 'IssueRemoveModal',

    data() {
        return {
            issueId: null,
            open: false,
            isLoading: false
        }
    },

    methods: {
        cancel() {
            this.open = false
            this.$emit('cancel', this.issueId)
        },
        ok() {
            this.isLoading = true
            this.$emit('ok', this.issueId, this.closeModal)
        },
        closeModal() {
            this.open = false
            this.isLoading = false
        }
    },

    mounted() {
        this.$on('open', (issueId) => {
            this.issueId = issueId
            this.open = true
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_remove_issue {
    text-align: center;

    &__content {
        margin: 1.5rem 0;
    }
    &__question {
        color: $c-red;
        margin-bottom: 2rem;
    }
    button {
        margin: .5rem;
    }
}

</style>
